import { h, Component } from 'preact';
import style from './style.less';

export default class NewsFeed extends Component {
	render() {
		return <div>
			<h1>News Feed</h1>
		</div>

// <div class={"row " + style.container}>
// <div class="col col-3 row">
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
// </div>
// <div class="col col-3 row">
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
// </div>
// <div class="col col-3 row">
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
// </div>
// <div class="col col-3 row">
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
//     <div class="col col-lg-3 col-md-6">&nbsp;</div>
// </div>
// </div>
	}
}



// WEBPACK FOOTER //
// ./components/elements/newsfeed/index.js